// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1mpL2","right":"Footer_right__2gkyB","buttons":"Footer_buttons__M4Nv6"};